// reducers/login.js
import * as actionTypes from "../actionTypes";


const initialState = {
};

const authReducer = (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    // case actionTypes.SET_IS_LOADING: {
    //   return {
    //     ...state,
    //     isLoading: payload
    //   }
    // }
    default:
      return state;
  }
};

export default authReducer;
